<template>
      <!-- Table with sorting, filtering, and pagination -->
      <EasyDataTable
      
      :headers="headers"
      :items="items"
      :sort-by="sortBy"
      :sort-type="sortType"
      table-class-name="customize-table"
      theme-color="#007791"
      alternating
      border-cell
      />

  </template>
  
  
  <script>
  import EasyDataTable from 'vue3-easy-data-table';
  //const EasyDataTable= window['vue3-easy-data-table'];
  //console.log("import try", EasyDataTable)
  
  export default {
    components: {
      EasyDataTable,
    },
    data() {
      return {
        api_address : process.env.VUE_APP_api_address,
        // Example data to be displayed in the table
        headers:[
          { text: "Station", value: "sta",  sortable: true},
          { text: "lon[deg]", value: "s_lon[deg]", sortable: true },
          { text: "lat[deg]", value: "s_lat[deg]", sortable: true },
          { text: "RF?", value: "RF?", sortable: true },
          { text: "earthquake date", value: "date", sortable: true },
          { text: "earthquake Mw", value: "Mw", sortable: true },
          { text: "earthquake location", value: "location", sortable: true },
          { text: "earthquake lon[deg]", value: "e_lon[deg]", sortable: true },
          { text: "earthquake lat[deg]", value: "e_lat[deg]", sortable: true },
          { text: "Distance [km]", value: "dist[km]", sortable: true },
          { text: "displ.1 dE[mm]", value: "d1_dE[mm]", sortable: true },
          { text: "displ.1 dN[mm]", value: "d1_dN[mm]", sortable: true },
          { text: "displ.1 dU[mm]", value: "d1_dU[mm]", sortable: true },
          { text: "displ.2 dE[mm]", value: "d2_dE[mm]", sortable: true },
          { text: "displ.2 dN[mm]", value: "d2_dN[mm]", sortable: true },
          { text: "displ.2 dU[mm]", value: "d2_dU[mm]", sortable: true },
        ],
        // Define the columns for the table
        items: [],
        // Sorting options
      sortBy: 'date',
      sortType: 'desc',
        
      };
    },

    async mounted(){

      var response = await fetch(this.api_address+"/coseismic_format", {
            method: 'get',
            headers:{
              "Access-Control-Allow-Origin": "*",
            }
          }).then(response => response.json());

      this.items = response

    }
  };
  </script>

  <style>
  .customize-table{
    --easy-table-header-font-size: 12px;
    --easy-table-header-item-padding: 5px 5px;
    --easy-table-body-item-padding: 5px 5px;
  }


  </style>
